import { CustomColumn } from '@dcl/ui/dist/fragments/DataGrid/DataGridTypes';
import { IFileDownloadExperience, ITableHeader, ITableRow } from './types';
import { HTML_MESSAGE } from './constants';
const tableHeadersData: ITableHeader[] = [
  {
    header: 'Title',
    accessor: 'col1',
    sortable: true,
    type: 'link',
    searchable: true,
    filterable: true,
  },
  {
    header: 'Category',
    accessor: 'col2',
    sortable: true,
    type: 'link',
    searchable: true,
    filterable: true,
    isInternal: true,
  },
  {
    header: 'Description',
    accessor: 'col3',
    sortable: true,
    type: 'text',
    searchable: true,
  },
  {
    header: 'Last updated',
    accessor: 'col4',
    sortable: true,
    type: 'text',
    searchable: true,
    filterable: true,
    isInternal: false,
  },
  {
    header: 'Action',
    accessor: 'col5',
    sortable: false,
    type: 'button',
    searchable: true,
  },
];
export const tableBodyData: ITableRow[] = [
  {
    tableData: [
      {
        accessor: 'col1',
        value: '01/31/2019',
        link: 'https://www.google.com',
        newTab: true,
        buttonName: '',
      },
      {
        accessor: 'col2',
        value: 'Elient Management 3',
        link: '',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col3',
        value: 'external File',
        link: '',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col4',
        value: '09/02/2023',
        link: '',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col5',
        value: '',
        link: '/helpandsupp/gb/digita-suite/external/digita-suite-jun25.zip',
        newTab: true,
        buttonName: 'Download',
      },
    ],
  },
  {
    isInternal: true,
    tableData: [
      {
        accessor: 'col1',
        value: '03/01/2020',
        link: 'https://www.google.com',
        newTab: true,
        buttonName: '',
      },
      {
        accessor: 'col2',
        value: 'Fell text',
        link: 'https://www.google.com',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col3',
        value: 'Cell text',
        link: '',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col4',
        value: '01/26/2023',
        link: '',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col5',
        value: '',
        link: 'helpandsupp/us/practice-cs/internal/practicecsdownload_2019.zip',
        newTab: true,
        buttonName: 'Download',
      },
    ],
  },
  {
    tableData: [
      {
        accessor: 'col1',
        value: '03/08/2018',
        link: 'https://www.google.com',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col2',
        value: 'Alient Management3',
        link: '',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col3',
        value: 'Demp test 3',
        link: '',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col4',
        value: '09/01/2019',
        link: '',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col5',
        value: '',
        link:
          'helpandsupp/us/accounting-cs-family/gated/acs-client-templates.zip',
        newTab: true,
        buttonName: 'Download',
      },
    ],
  },
  {
    tableData: [
      {
        accessor: 'col1',
        value: 'BILLING ACTIVITY',
        link: 'https://www.google.com',
        newTab: true,
        buttonName: '',
      },
      {
        accessor: 'col2',
        value: 'Cell text',
        link: 'https://www.google.com',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col3',
        value: 'Cell text',
        link: '',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col4',
        value: '08/01/2019',
        link: '',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col5',
        value: '',
        link: '/helpandsupp/us/planner-cs/internal/plannercs_cd2110.zip',
        newTab: true,
        buttonName: 'Download',
      },
    ],
  },
  {
    tableData: [
      {
        accessor: 'col1',
        value: 'COPY CAT content dam',
        link: 'https://www.google.com',
        newTab: true,
        buttonName: '',
      },
      {
        accessor: 'col2',
        value: 'Client Management 3',
        link: '',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col3',
        value: 'Demp test 3',
        link: '',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col4',
        value: '12/28/2020',
        link: '',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col5',
        value: '',
        link: 'content/dam/nvs/releases/download/v1.7.0/nvs-1.7.0.msi',
        newTab: true,
        buttonName: 'Download',
      },
    ],
  },
  {
    tableData: [
      {
        accessor: 'col1',
        value: 'Copy cat',
        link: 'https://www.google.com',
        newTab: true,
        buttonName: '',
      },
      {
        accessor: 'col2',
        value: 'Cell text',
        link: '',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col3',
        value: 'Cell text',
        link: '',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col4',
        value: '03/01/2020',
        link: '',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col5',
        value: '',
        link:
          'https://github.com/jasongin/nvs/releases/download/v1.7.0/nvs-1.7.0.msi',
        newTab: true,
        buttonName: 'Download',
      },
    ],
  },
  {
    tableData: [
      {
        accessor: 'col1',
        value: 'Copy Cat',
        link: '',
        newTab: true,
        buttonName: '',
      },
      {
        accessor: 'col2',
        value: 'Client Management 3',
        link: 'https://www.google.com',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col3',
        value: 'Demp test 3',
        link: '',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col4',
        value: '09/01/2023',
        link: '',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col5',
        value: '',
        link:
          'https://github.com/jasongin/nvs/releases/download/v1.7.0/nvs-1.7.0.msi',
        newTab: true,
        buttonName: 'Download',
      },
    ],
  },
  {
    tableData: [
      {
        accessor: 'col1',
        value: 'copy cat',
        link: 'https://www.google.com',
        newTab: true,
        buttonName: '',
      },
      {
        accessor: 'col2',
        value: 'Cell text',
        link: '',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col3',
        value: 'Cell text',
        link: '',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col4',
        value: '01/31/2019',
        link: '',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col5',
        value: '',
        link:
          'https://github.com/jasongin/nvs/releases/download/v1.7.0/nvs-1.7.0.msi',
        newTab: true,
        buttonName: 'Download',
      },
    ],
  },
  {
    tableData: [
      {
        accessor: 'col1',
        value: 'Interaction Listing Alternate 7',
        link: 'https://www.google.com',
        newTab: true,
        buttonName: '',
      },
      {
        accessor: 'col2',
        value: 'Client Management 3',
        link: '',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col3',
        value: 'Demp test 3',
        link: '',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col4',
        value: '03/01/2020',
        link: '',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col5',
        value: '',
        link:
          'https://github.com/jasongin/nvs/releases/download/v1.7.0/nvs-1.7.0.msi',
        newTab: true,
        buttonName: 'Download',
      },
    ],
  },
  {
    tableData: [
      {
        accessor: 'col1',
        value: 'Interaction Listing Alternate 2',
        link: 'https://www.google.com',
        newTab: true,
        buttonName: '',
      },
      {
        accessor: 'col2',
        value: 'Cell text',
        link: '',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col3',
        value: 'Cell text',
        link: '',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col4',
        value: '03/08/2018',
        link: '',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col5',
        value: '',
        link:
          'https://github.com/jasongin/nvs/releases/download/v1.7.0/nvs-1.7.0.msi',
        newTab: true,
        buttonName: 'Download',
      },
    ],
  },
  {
    tableData: [
      {
        accessor: 'col1',
        value: 'Interaction Listing Alternate 6',
        link: 'https://www.google.com',
        newTab: true,
        buttonName: '',
      },
      {
        accessor: 'col2',
        value: 'Client Management 3',
        link: '',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col3',
        value: 'Demp test 3',
        link: '',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col4',
        value: '09/01/2023',
        link: '',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col5',
        value: '',
        link:
          'https://github.com/jasongin/nvs/releases/download/v1.7.0/nvs-1.7.0.msi',
        newTab: true,
        buttonName: 'Download',
      },
    ],
  },
  {
    tableData: [
      {
        accessor: 'col1',
        value: 'Interaction Listing Alternate 2',
        link: '',
        newTab: true,
        buttonName: '',
      },
      {
        accessor: 'col2',
        value: 'Dell text',
        link: '',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col3',
        value: 'Aell text',
        link: '',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col4',
        value: '01/24/2023',
        link: '',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col5',
        value: '',
        link:
          'https://github.com/jasongin/nvs/releases/download/v1.7.0/nvs-1.7.0.msi',
        newTab: true,
        buttonName: 'Download',
      },
    ],
  },
  {
    tableData: [
      {
        accessor: 'col1',
        value: 'Interaction Listing Alternate 8',
        link: 'https://www.google.com',
        newTab: true,
        buttonName: '',
      },
      {
        accessor: 'col2',
        value: 'Dlient Management 3',
        link: '',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col3',
        value: 'Demp test 3',
        link: '',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col4',
        value: '09/01/2023',
        link: '',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col5',
        value: '',
        link:
          'https://github.com/jasongin/nvs/releases/download/v1.7.0/nvs-1.7.0.msi',
        newTab: true,
        buttonName: 'Download',
      },
    ],
  },
  {
    tableData: [
      {
        accessor: 'col1',
        value: 'Interaction Listing Alternate 2',
        link: 'https://www.google.com',
        newTab: true,
        buttonName: '',
      },
      {
        accessor: 'col2',
        value: 'Eell text',
        link: '',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col3',
        value: 'Cell text',
        link: '',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col4',
        value: '01/24/2023',
        link: '',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col5',
        value: '',
        link:
          'https://github.com/jasongin/nvs/releases/download/v1.7.0/nvs-1.7.0.msi',
        newTab: true,
        buttonName: 'Download',
      },
    ],
  },
  {
    tableData: [
      {
        accessor: 'col1',
        value: 'Interaction Listing Alternate 3',
        link: 'https://www.google.com',
        newTab: true,
        buttonName: '',
      },
      {
        accessor: 'col2',
        value: 'Client Management 3',
        link: '',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col3',
        value: 'Femp test 3',
        link: '',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col4',
        value: '09/01/2023',
        link: '',
        newTab: false,
        buttonName: '',
      },
      {
        accessor: 'col5',
        value: '',
        link:
          'https://github.com/jasongin/nvs/releases/download/v1.7.0/nvs-1.7.0.msi',
        newTab: true,
        buttonName: 'Download',
      },
    ],
  },
];
const tableHeadersAlertAndNoticesData: ITableHeader[] = [
  {
    header: 'Title',
    accessor: 'col1',
    sortable: true,
    type: 'link',
    searchable: true,
    filterable: true,
  },
  {
    header: 'Category',
    accessor: 'col2',
    sortable: true,
    type: 'text',
    searchable: true,
    filterable: true,
  },
  {
    header: 'Last updated',
    accessor: 'col3',
    sortable: true,
    type: 'text',
    searchable: false,
    filterable: true,
  },
  {
    header: 'Action',
    accessor: 'col4',
    sortable: false,
    type: 'button',
    searchable: false,
    filterable: false,
  },
];
const tableBodyAlertAndNoticesData: ITableRow[] = [
  {
    tableData: [
      {
        value: 'Some text',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.pdf',
        newTab: true,
      },
      {
        value: 'Firm',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '12/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: "Hello'how can i help you'?",
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.pdf',
        newTab: true,
      },
      {
        value: 'Firm',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '11/12/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: "Hello 'how can i help you'?",
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.pdf',
        newTab: true,
      },
      {
        value: 'Firm',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '07/13/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'text@20.com',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.pdf',
        newTab: true,
      },
      {
        value: 'Firm',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: '1001.235',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.pdf',
        newTab: true,
      },
      {
        value: 'Firm',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: '2/12/2023',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.pdf',
        newTab: true,
      },
      {
        value: 'Firm',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Client Customer Counts',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.pdf',
        newTab: true,
      },
      {
        value: 'Firm',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Text replacing spaces.',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.pdf',
        newTab: true,
      },
      {
        value: 'Firm',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Text replacing blank.',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.pdf',
        newTab: true,
      },
      {
        value: 'Firm',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: '1/12/2023',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.pdf',
        newTab: true,
      },
      {
        value: 'Firm',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: '13/1/2023',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.pdf',
        newTab: true,
      },
      {
        value: 'Firm',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: '1/12/2023',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.pdf',
        newTab: true,
      },
      {
        value: 'Firm',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: '-1001',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.pdf',
        newTab: true,
      },
      {
        value: 'Firm',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'text@22.com',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.pdf',
        newTab: true,
      },
      {
        value: 'Firm',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'text@21.com',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.pdf',
        newTab: true,
      },
      {
        value: 'Firm',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: '1001.24',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.pdf',
        newTab: true,
      },
      {
        value: 'Firm',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: '1001.23',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.pdf',
        newTab: true,
      },
      {
        value: 'Firm',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: '190$',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.pdf',
        newTab: true,
      },
      {
        value: 'Firm',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: '100$',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.pdf',
        newTab: true,
      },
      {
        value: 'Firm',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: '3e',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.pdf',
        newTab: true,
      },
      {
        value: 'Firm',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Billing activity',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.pdf',
        newTab: true,
      },
      {
        value: 'Firm',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'billing activity',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.pdf',
        newTab: true,
      },
      {
        value: 'Firm',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Billing Activity',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.pdf',
        newTab: true,
      },
      {
        value: 'Firm',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Billing_Activity.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Client Address Labels - Avery 5160',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Client_Address_Labels_-_Avery_5160.pdf',
        newTab: true,
      },
      {
        value: 'Firm',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Client_Address_Labels_-_Avery_5160.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Client Customer Counts',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Client_Customer_Counts.pdf',
        newTab: true,
      },
      {
        value: 'Firm',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '08/01/2019',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Client_Customer_Counts.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Client Employee Counts',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Client_Employee_Counts.pdf',
        newTab: true,
      },
      {
        value: 'Firm',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '08/01/2019',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Client_Employee_Counts.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Client Vendor Counts',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Client_Vendor_Counts.pdf',
        newTab: true,
      },
      {
        value: 'Firm',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '08/01/2019',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Client_Vendor_Counts.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Client Workpaper Counts',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Client_Workpaper_Counts.pdf',
        newTab: true,
      },
      {
        value: 'Firm',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '08/01/2019',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Client_Workpaper_Counts.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Missing W-2 Information',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Missing_W-2_Information.pdf',
        newTab: true,
      },
      {
        value: 'Firm',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Missing_W-2_Information.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Staff Address Labels - Avery 5160',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Staff_Address_Labels_-_Avery_5160.pdf',
        newTab: true,
      },
      {
        value: 'Firm',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Staff_Address_Labels_-_Avery_5160.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Account Groupings - Grouped by Type',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Account_Groupings_-_Grouped_by_Type.pdf',
        newTab: true,
      },
      {
        value: 'Accounting',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '07/01/2017',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Account_Groupings_-_Grouped_by_Type.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Chart of Accounts - Detailed - Two Account Groupings',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Chart_of_Accounts_-_Detailed_-_Two_Account_Groupings.pdf',
        newTab: true,
      },
      {
        value: 'Accounting',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Chart_of_Accounts_-_Detailed_-_Two_Account_Groupings.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Deposit List - General Ledger Summary',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Deposit_List_-_General_Ledger_Summary.pdf',
        newTab: true,
      },
      {
        value: 'Accounting',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Deposit_List_-_General_Ledger_Summary.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'General Ledger - Grouped by Core Account',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/General_Ledger_-_Grouped_by_Core_Account.pdf',
        newTab: true,
      },
      {
        value: 'Accounting',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/General_Ledger_-_Grouped_by_Core_Account.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Net Income Worksheet',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Net_Income_Worksheet.pdf',
        newTab: true,
      },
      {
        value: 'Accounting',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Net_Income_Worksheet.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Payment List - General Ledger Summary',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Payment_List_-_General_Ledger_Summary.pdf',
        newTab: true,
      },
      {
        value: 'Accounting',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Payment_List_-_General_Ledger_Summary.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Transaction Date and Posting Period Mismatch Worksheet',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Transaction_Date_and_Posting_Period_Mismatch_Worksheet.pdf',
        newTab: true,
      },
      {
        value: 'Accounting',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Transaction_Date_and_Posting_Period_Mismatch_Worksheet.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Transaction List - Grouped by Account',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Transaction_List_-_Grouped_by_Account.pdf',
        newTab: true,
      },
      {
        value: 'Accounting',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Transaction_List_-_Grouped_by_Account.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Transaction Notes List',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Transaction_Notes_List.pdf',
        newTab: true,
      },
      {
        value: 'Accounting',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '03/08/2018',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Transaction_Notes_List.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Trial Balance - Condensed - Grouped by Core Account',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Trial_Balance_-_Condensed_-_Grouped_by_Core_Account.pdf',
        newTab: true,
      },
      {
        value: 'Accounting',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Trial_Balance_-_Condensed_-_Grouped_by_Core_Account.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Trial Balance - Condensed - Grouped by Type',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Trial_Balance_-_Condensed_-_Grouped_by_Type.pdf',
        newTab: true,
      },
      {
        value: 'Accounting',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Trial_Balance_-_Condensed_-_Grouped_by_Type.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value:
          'Trial Balance - Condensed - Zero Balance Accounts with Activity',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Trial_Balance_-_Condensed_-_Zero_Balance_Accounts_with_Activity.pdf',
        newTab: true,
      },
      {
        value: 'Accounting',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Trial_Balance_-_Condensed_-_Zero_Balance_Accounts_with_Activity.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Trial Balance Worksheet - Grouped by Type',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Trial_Balance_Worksheet_-_Grouped_by_Type.pdf',
        newTab: true,
      },
      {
        value: 'Accounting',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '07/01/2017',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Trial_Balance_Worksheet_-_Grouped_by_Type.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Vendor Address Labels - Avery 5160',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Vendor_Address_Labels_-_Avery_5160.pdf',
        newTab: true,
      },
      {
        value: 'Accounting',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Vendor_Address_Labels_-_Avery_5160.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Open Payable and Payment List - Condensed',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Open_Payable_and_Payment_List_-_Condensed.pdf',
        newTab: true,
      },
      {
        value: 'Accounts Payable',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Open_Payable_and_Payment_List_-_Condensed.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Open Payable and Payment List - Detailed',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Open_Payable_and_Payment_List_-_Detailed.pdf',
        newTab: true,
      },
      {
        value: 'Accounts Payable',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Open_Payable_and_Payment_List_-_Detailed.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value:
          'Vendor Activity - Condensed - With Discount Allowed and Remaining',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Vendor_Activity_-_Condensed_-_With_Discount_Allowed_and_Remaining.pdf',
        newTab: true,
      },
      {
        value: 'Accounts Payable',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Vendor_Activity_-_Condensed_-_With_Discount_Allowed_and_Remaining.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value:
          'Customer Activity - Condensed - With Discount Offered and Remaining',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Customer_Activity_-_Condensed_-_With_Discount_Offered_and_Remaining.pdf',
        newTab: true,
      },
      {
        value: 'Accounts Receivable',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Customer_Activity_-_Condensed_-_With_Discount_Offered_and_Remaining.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Customer Address Labels - Avery 5160',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Customer_Address_Labels_-_Avery_5160.pdf',
        newTab: true,
      },
      {
        value: 'Accounts Receivable',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Customer_Address_Labels_-_Avery_5160.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Open Invoice and Payment List - Condensed',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Open_Invoice_and_Payment_List_-_Condensed.pdf',
        newTab: true,
      },
      {
        value: 'Accounts Receivable',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Open_Invoice_and_Payment_List_-_Condensed.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Open Invoice and Payment List - Detailed',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Open_Invoice_and_Payment_List_-_Detailed.pdf',
        newTab: true,
      },
      {
        value: 'Accounts Receivable',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Open_Invoice_and_Payment_List_-_Detailed.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Sales Tax - Detailed - Optional Accounting Method',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Sales_Tax_-_Detailed_-_Optional_Accounting_Method.pdf',
        newTab: true,
      },
      {
        value: 'Accounts Receivable',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '08/01/2017',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Sales_Tax_-_Detailed_-_Optional_Accounting_Method.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: '940 Worksheet',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/940_Worksheet.pdf',
        newTab: true,
      },
      {
        value: 'Payroll',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '01/31/2019',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/940_Worksheet.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: '941 Worksheet',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/941_Worksheet.pdf',
        newTab: true,
      },
      {
        value: 'Payroll',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '09/28/2017',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/941_Worksheet.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: '7200 Worksheet - COVID-19',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/7200_Worksheet_-_COVID-19.pdf',
        newTab: true,
      },
      {
        value: 'Payroll',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '07/12/2021',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/7200_Worksheet_-_COVID-19.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Average Payroll Cost Worksheet',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Average_Payroll_Cost_Worksheet.pdf',
        newTab: true,
      },
      {
        value: 'Payroll',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '11/28/2020',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Average_Payroll_Cost_Worksheet.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Cash Requirements and Deposits - COVID-19',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Cash_Requirements_and_Deposits_-_COVID-19.pdf',
        newTab: true,
      },
      {
        value: 'Payroll',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '04/22/2021',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Cash_Requirements_and_Deposits_-_COVID-19.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value:
          'Cash Requirements and Deposits - Location and Department Totals',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Cash_Requirements_and_Deposits_-_Location_and_Department_Totals.pdf',
        newTab: true,
      },
      {
        value: 'Payroll',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Cash_Requirements_and_Deposits_-_Location_and_Department_Totals.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value:
          'Data Entry Worksheet - Grouped by Location and Department Allocation',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Data_Entry_Worksheet_-_Grouped_by_Location_and_Department_Allocation.pdf',
        newTab: true,
      },
      {
        value: 'Payroll',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '03/01/2020',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Data_Entry_Worksheet_-_Grouped_by_Location_and_Department_Allocation.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Data Entry Worksheet - Grouped by Primary Department',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Data_Entry_Worksheet_-_Grouped_by_Primary_Department.pdf',
        newTab: true,
      },
      {
        value: 'Payroll',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '03/01/2020',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Data_Entry_Worksheet_-_Grouped_by_Primary_Department.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Data Entry Worksheet - Short Form',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Data_Entry_Worksheet_-_Short_Form.pdf',
        newTab: true,
      },
      {
        value: 'Payroll',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '07/01/2017',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Data_Entry_Worksheet_-_Short_Form.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value:
          'Data Entry Worksheet - Short Form - Grouped by Location and Department Allocation',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Data_Entry_Worksheet_-_Short_Form_-_Grouped_by_Location_and_Department_Allocation.pdf',
        newTab: true,
      },
      {
        value: 'Payroll',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '07/01/2017',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Data_Entry_Worksheet_-_Short_Form_-_Grouped_by_Location_and_Department_Allocation.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value:
          'Data Entry Worksheet - Short Form - Grouped by Primary Department',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Data_Entry_Worksheet_-_Short_Form_-_Grouped_by_Primary_Department.pdf',
        newTab: true,
      },
      {
        value: 'Payroll',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '07/01/2017',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Data_Entry_Worksheet_-_Short_Form_-_Grouped_by_Primary_Department.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Deduction Register - Columnar',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Deduction_Register_-_Columnar.pdf',
        newTab: true,
      },
      {
        value: 'Payroll',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '11/13/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Deduction_Register_-_Columnar.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value:
          'Deduction Register - Grouped by Location and Department Allocation',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Deduction_Register_-_Grouped_by_Location_and_Department_Allocation.pdf',
        newTab: true,
      },
      {
        value: 'Payroll',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/29/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Deduction_Register_-_Grouped_by_Location_and_Department_Allocation.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Depository Totals - COVID-19',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Depository_Totals_-_COVID-19.pdf',
        newTab: true,
      },
      {
        value: 'Payroll',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '04/22/2021',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Depository_Totals_-_COVID-19.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value:
          'Depository Totals - Grouped by Location and Department Allocation',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Depository_Totals_-_Grouped_by_Location_and_Department_Allocation.pdf',
        newTab: true,
      },
      {
        value: 'Payroll',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '09/01/2017',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Depository_Totals_-_Grouped_by_Location_and_Department_Allocation.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'EFTPS Payment Worksheet - COVID-19',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/EFTPS_Payment_Worksheet_-_COVID-19.pdf',
        newTab: true,
      },
      {
        value: 'Payroll',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '04/22/2021',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/EFTPS_Payment_Worksheet_-_COVID-19.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'EFTPS Phone Payment Worksheet - COVID-19',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/EFTPS_Phone_Payment_Worksheet_-_COVID-19.pdf',
        newTab: true,
      },
      {
        value: 'Payroll',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '04/22/2021',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/EFTPS_Phone_Payment_Worksheet_-_COVID-19.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Employee Address Labels - Avery 5160',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Employee_Address_Labels_-_Avery_5160.pdf',
        newTab: true,
      },
      {
        value: 'Payroll',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/08/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Employee_Address_Labels_-_Avery_5160.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value:
          'Employee Earnings - Grouped by Location and Department Allocation per Employee',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Employee_Earnings_-_Grouped_by_Location_and_Department_Allocation_per_Employee.pdf',
        newTab: true,
      },
      {
        value: 'Payroll',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Employee_Earnings_-_Grouped_by_Location_and_Department_Allocation_per_Employee.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Employee Earnings - Portrait',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Employee_Earnings_-_Portrait.pdf',
        newTab: true,
      },
      {
        value: 'Payroll',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Employee_Earnings_-_Portrait.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Employee Earnings with Detailed Hours - Portrait',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Employee_Earnings_with_Detailed_Hours_-_Portrait.pdf',
        newTab: true,
      },
      {
        value: 'Payroll',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Employee_Earnings_with_Detailed_Hours_-_Portrait.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Employee Retention Credit Summary',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Employee_Retention_Credit_Summary.pdf',
        newTab: true,
      },
      {
        value: 'Payroll',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '04/22/2021',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Employee_Retention_Credit_Summary.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value:
          'Payroll Journal - Condensed - Grouped by Location and Department Allocation',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Payroll_Journal_-_Condensed_-_Grouped_by_Location_and_Department_Allocation.pdf',
        newTab: true,
      },
      {
        value: 'Payroll',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Payroll_Journal_-_Condensed_-_Grouped_by_Location_and_Department_Allocation.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value:
          'Payroll Journal - Detailed - Grouped by Location and Department Allocation - Landscape',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Payroll_Journal_-_Detailed_-_Grouped_by_Location_and_Department_Allocation_-_Landscape.pdf',
        newTab: true,
      },
      {
        value: 'Payroll',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Payroll_Journal_-_Detailed_-_Grouped_by_Location_and_Department_Allocation_-_Landscape.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value:
          'Payroll Journal - Detailed - Grouped by Location and Department Allocation - Portrait',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Payroll_Journal_-_Detailed_-_Grouped_by_Location_and_Department_Allocation_-_Portrait.pdf',
        newTab: true,
      },
      {
        value: 'Payroll',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Payroll_Journal_-_Detailed_-_Grouped_by_Location_and_Department_Allocation_-_Portrait.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value:
          'Payroll Journal - Detailed - Optional Garnishment Order Details',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Payroll_Journal_-_Detailed_-_Optional_Garnishment_Order_Details.pdf',
        newTab: true,
      },
      {
        value: 'Payroll',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Payroll_Journal_-_Detailed_-_Optional_Garnishment_Order_Details.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Payroll Tax Summary - Check Detail',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Payroll_Tax_Summary_-_Check_Detail.pdf',
        newTab: true,
      },
      {
        value: 'Payroll',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '09/10/2020',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Payroll_Tax_Summary_-_Check_Detail.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'PPP Loan Forgiveness Payroll Worksheet',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/PPP_Loan_Forgiveness_Payroll_Worksheet.pdf',
        newTab: true,
      },
      {
        value: 'Payroll',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '06/30/2020',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/PPP_Loan_Forgiveness_Payroll_Worksheet.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Preprocessing Summary - COVID-19',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Preprocessing_Summary_-_COVID-19.pdf',
        newTab: true,
      },
      {
        value: 'Payroll',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '04/22/2021',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Preprocessing_Summary_-_COVID-19.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Retirement Plan Worksheet',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Retirement_Plan_Worksheet.pdf',
        newTab: true,
      },
      {
        value: 'Payroll',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Retirement_Plan_Worksheet.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value:
          'Unprinted Payroll Checks - Grouped by Location and Department Allocation - Landscape',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Unprinted_Payroll_Checks_-_Grouped_by_Location_and_Department_Allocation_-_Landscape.pdf',
        newTab: true,
      },
      {
        value: 'Payroll',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Unprinted_Payroll_Checks_-_Grouped_by_Location_and_Department_Allocation_-_Landscape.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value:
          'Unprinted Payroll Checks - Grouped by Location and Department Allocation - Portrait',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Unprinted_Payroll_Checks_-_Grouped_by_Location_and_Department_Allocation_-_Portrait.pdf',
        newTab: true,
      },
      {
        value: 'Payroll',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Unprinted_Payroll_Checks_-_Grouped_by_Location_and_Department_Allocation_-_Portrait.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Wage Register - Grouped by Location and Department Allocation',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Wage_Register_-_Grouped_by_Location_and_Department_Allocation.pdf',
        newTab: true,
      },
      {
        value: 'Payroll',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Wage_Register_-_Grouped_by_Location_and_Department_Allocation.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value:
          "Workers' Compensation - Condensed - Grouped by Location and Department Allocation per State",
        buttonName: '',
        accessor: 'col1',
        link:
          "/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Workers'_Compensation_-_Condensed_-_Grouped_by_Location_and_Department_Allocation_per_State.pdf",
        newTab: true,
      },
      {
        value: 'Payroll',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          "/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Workers'_Compensation_-_Condensed_-_Grouped_by_Location_and_Department_Allocation_per_State.zip",
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value:
          "Workers' Compensation - Detailed - Grouped by Location and Department Allocation per State",
        buttonName: '',
        accessor: 'col1',
        link:
          "/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Workers'_Compensation_-_Detailed_-_Grouped_by_Location_and_Department_Allocation_per_State.pdf",
        newTab: true,
      },
      {
        value: 'Payroll',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          "/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Workers'_Compensation_-_Detailed_-_Grouped_by_Location_and_Department_Allocation_per_State.zip",
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Balance Sheet - Current Period - Current Year -Quarterly',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Balance_Sheet_-_Current_Period_-_Current_Year_-_Quarterly.pdf',
        newTab: true,
      },
      {
        value: 'Financial Statement',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '04/01/2021',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Balance_Sheet_-_Current_Period_-_Current_Year_-_Quarterly.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value:
          'Balance Sheet - Current Quarter - Prior Quarter - Variance Percent',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Balance_Sheet_-_Current_Quarter_-_Prior_Quarter_-_Variance_Percent.pdf',
        newTab: true,
      },
      {
        value: 'Financial Statement',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '04/01/2021',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Balance_Sheet_-_Current_Quarter_-_Prior_Quarter_-_Variance_Percent.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Balance Sheet - Current Year - Overdraft',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Balance_Sheet_-_Current_Year_-_Overdraft.pdf',
        newTab: true,
      },
      {
        value: 'Financial Statement',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '07/01/2017',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Balance_Sheet_-_Current_Year_-_Overdraft.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Balance Sheet - Current Year - Segment Comparison',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Balance_Sheet_-_Current_Year_-_Segment_Comparison.pdf',
        newTab: true,
      },
      {
        value: 'Financial Statement',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Balance_Sheet_-_Current_Year_-_Segment_Comparison.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Balance Sheet - Current Year - Summary - Overdraft',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Balance_Sheet_-_Current_Year_-_Summary_-_Overdraft.pdf',
        newTab: true,
      },
      {
        value: 'Financial Statement',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '07/01/2017',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Balance_Sheet_-_Current_Year_-_Summary_-_Overdraft.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Income Statement - Current Period - Current Year - Quarterly',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Income_Statement_-_Current_Period_-_Current_Year_-_Quarterly.pdf',
        newTab: true,
      },
      {
        value: 'Financial Statement',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Income_Statement_-_Current_Period_-_Current_Year_-_Quarterly.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value:
          'Income Statement - Current Quarter - Prior Quarter - Variance Percent',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Income_Statement_-_Current_Quarter_-_Prior_Quarter_-_Variance_Percent.pdf',
        newTab: true,
      },
      {
        value: 'Financial Statement',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '04/01/2021',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Income_Statement_-_Current_Quarter_-_Prior_Quarter_-_Variance_Percent.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Income Statement - Current Year - Segment Comparison',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Income_Statement_-_Current_Year_-_Segment_Comparison.pdf',
        newTab: true,
      },
      {
        value: 'Financial Statement',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '10/10/2016',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Income_Statement_-_Current_Year_-_Segment_Comparison.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: '@Direct Deposit Authorization',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Direct_Deposit_Authorization.pdf',
        newTab: true,
      },
      {
        value: 'Letter',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '03/08/2018',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Direct_Deposit_Authorization.zip',
        newTab: false,
      },
    ],
  },
  {
    tableData: [
      {
        value: 'Employee Direct Deposit Authorization',
        buttonName: '',
        accessor: 'col1',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Employee_Direct_Deposit_Authorization.pdf',
        newTab: true,
      },
      {
        value: 'Letter',
        buttonName: '',
        accessor: 'col2',
        link: '',
        newTab: false,
      },
      {
        value: '03/08/2018',
        buttonName: '',
        accessor: 'col3',
        link: '',
        newTab: false,
      },
      {
        value: '',
        buttonName: 'Download',
        accessor: 'col4',
        link:
          '/content/dam/helpandsupp/en-us/Topics/accounting-cs-family/files/custom-reports/Employee_Direct_Deposit_Authorization.zip',
        newTab: false,
      },
    ],
  },
];

export const fileDownloadExperienceMock: IFileDownloadExperience = {
  pageTitle: 'Accounting CS files to use with Report Designer',
  pageDescription: HTML_MESSAGE,
  searchTitle: 'Search by title or description of file',
  tableHeaderProps: tableHeadersData,
  tableDataProps: tableBodyData,
  internalUseText: 'For Internal use only',
  baseUrlHost: 'http://example.com',
  emptySearchMsg:
    'We didn’t find any results for Search term. Try a different title or description.',
  fileDownloadUrl: 'https://z827ayop6i.execute-api.us-east-1.amazonaws.com',
};

export const alertAndNoticesMock: IFileDownloadExperience = {
  pageTitle: 'Alerts and Notices for Accounting CS',
  pageDescription: HTML_MESSAGE,
  searchTitle: 'Search by alert',
  tableHeaderProps: tableHeadersAlertAndNoticesData,
  tableDataProps: tableBodyAlertAndNoticesData,
  emptySearchMsg:
    'We didn’t find any results for Search term. Try a different title or description.',
  fileDownloadUrl: 'https://api-dev.asset.helpcenter.thomsonreuters.com',
};
export const columns3: CustomColumn<object>[] = [
  {
    Header: 'Title',
    accessor: 'col1',
    sortable: true,
    sortingAriaLabel: 'sort by column header',
    className: 'FileDownloadExperienceSearchResultDekstop-tableCol1',
  },
  {
    Header: 'Category',
    accessor: 'col2',
    className: 'FileDownloadExperienceSearchResultDekstop-tableCol2',
  },
  {
    Header: 'Description',
    accessor: 'col3',
    sortable: true,
    sortingAriaLabel: 'sort by column header',
    className: 'FileDownloadExperienceSearchResultDekstop-tableCol3',
  },
  {
    Header: 'Last Updated',
    accessor: 'col4',
    sortable: true,
    sortingAriaLabel: 'sort by column header',
    className: 'FileDownloadExperienceSearchResultDekstop-tableCol4',
  },
  {
    Header: 'Action',
    accessor: 'col5',
    sortable: false,
    sortingAriaLabel: 'sort by column header',
    className: 'FileDownloadExperienceSearchResultDekstop-tableCol5',
  },
];

export const fileDownloadSelectionMockData = [
  {
    label: 'Accounting CS',
    value:
      'https://cs.thomsonreuters.com/ua/acct_pr/acs/cs_us_en/default.htmAccounting CS',
  },
  {
    label: 'BEPS Action Manager',
    value:
      '/content/helpandsupp/en-us/help/beps-action-manager.htmlBEPS Action Manager',
  },
  {
    label: 'Checkpoint Classic',
    value:
      '/content/helpandsupp/en-us/help/checkpoint-classic.htmlCheckpoint Classic',
  },
  {
    label: 'Checkpoint Edge',
    value:
      '/content/helpandsupp/en-us/help/checkpoint-edge.htmlCheckpoint Edge',
  },
  {
    label: 'Checkpoint Engage',
    value:
      '/content/helpandsupp/en-us/help/checkpoint-engage.htmlCheckpoint Engage',
  },
  {
    label: 'Checkpoint Tools',
    value:
      '/content/helpandsupp/en-us/help/checkpoint-tools.htmlCheckpoint Tools',
  },
  {
    label: 'DAC6 Reporter',
    value: '/content/helpandsupp/en-us/help/dac6-reporter.htmlDAC6 Reporter',
  },
  {
    label: 'e-Form RS',
    value: '/content/helpandsupp/en-us/help/eform-rs.htmle-Form RS',
  },
];

export const headerDataMock = [
  {
    Header: 'Title',
    accessor: 'col1',
    sortable: true,
    sortingAriaLabel: 'sort by column header',
    className: 'FileDownloadExperienceSearchResultDekstop-tableCol1',
    filterable: true,
    internal: true,
  },
  {
    Header: 'Category',
    accessor: 'col2',
    sortable: true,
    sortingAriaLabel: 'sort by column header',
    className: 'FileDownloadExperienceSearchResultDekstop-tableCol2',
    filterable: true,
  },
  {
    Header: 'Last updated',
    accessor: 'col4',
    sortable: true,
    sortingAriaLabel: 'sort by column header',
    className: 'FileDownloadExperienceSearchResultDekstop-tableCol4',
    filterable: false,
  },
  {
    Header: 'Description',
    accessor: 'col3',
    sortable: true,
    sortingAriaLabel: 'sort by column header',
    className: 'FileDownloadExperienceSearchResultDekstop-tableCol3',
    filterable: false,
  },
  {
    Header: 'Action',
    accessor: 'col5',
    sortable: false,
    className: 'FileDownloadExperienceSearchResultDekstop-tableCol5',
    filterable: false,
  },
];

export const bodyDataMock = [
  {
    col1: '101e',
    col2: 'Refer to ADO #758624 when talking to Support',
    col3: 'Payroll',
    col4: '07/24/2023',
    col5: 'Open',
  },
  {
    col1:
      'zebra Microsoft ended support for SQL 2012 and earlier on July 12, 2022. You should have SQL Server 2014 (Service Pack 3) or higher installed on machines that run Accounting CS.',
    col2: 'Refer to ADO #758624 when talking to Support',
    col3: 'Payroll',
    col4: '07/24/2023',
    col5: 'Open',
  },
  {
    col1:
      'zebra Microsoft ended support for SQL 2012 and earlier on July 12, 2022. You should have SQL Server 2014 (Service Pack 3) or higher installed on machines that run Accounting CS.',
    col2: 'yaak Refer to ADO #758624 when talking to Support',
    col3: 'Payroll',
    col4: '07/24/2023',
    col5: 'Open',
  },
  {
    col1:
      'Microsoft ended support for SQL 2012 and earlier on July 12, 2022. You should have SQL Server 2014 (Service Pack 3) or higher installed on machines that run Accounting CS.',
    col2: 'Refer to ADO #758624 when talking to Support',
    col3: 'Payroll',
    col4: '07/24/2023',
    col5: 'Open',
  },
];

export const filterMockData = [
  {
    accessor: 'col1',
    cols: [
      {
        option: '101e',
        selected: false,
      },
      {
        option:
          'Microsoft ended support for SQL 2012 and earlier on July 12, 2022. You should have SQL Server 2014 (Service Pack 3) or higher installed on machines that run Accounting CS.',
        selected: false,
      },
      {
        option:
          'zebra Microsoft ended support for SQL 2012 and earlier on July 12, 2022. You should have SQL Server 2014 (Service Pack 3) or higher installed on machines that run Accounting CS.',
        selected: false,
      },
    ],
    header: 'Title',
  },
  {
    accessor: 'col2',
    cols: [
      {
        option: 'Refer to ADO #758624 when talking to Support',
        selected: false,
      },
      {
        option: 'yaak Refer to ADO #758624 when talking to Support',
        selected: false,
      },
    ],
    header: 'Category',
  },
];

export const filterMockSelectedData = [
  {
    accessor: 'col1',
    cols: [
      {
        option: '101e',
        selected: true,
      },
      {
        option:
          'Microsoft ended support for SQL 2012 and earlier on July 12, 2022. You should have SQL Server 2014 (Service Pack 3) or higher installed on machines that run Accounting CS.',
        selected: false,
      },
    ],
    header: 'Title',
  },
  {
    accessor: 'col2',
    cols: [
      {
        option: 'Refer to ADO #758624 when talking to Support',
        selected: false,
      },
    ],
    header: 'Category',
  },
  {
    accessor: 'col3',
    header: 'Category',
  },
];

export const filterBodyData = {
  filteredData: [
    {
      col1: '101e',
      col2: 'Refer to ADO #758624 when talking to Support',
      col3: 'Payroll',
      col4: '07/24/2023',
      col5: 'Open',
    },
  ],
};

export const External_Bearer_Token =
  'thomson-reuters-help-center-external-user';
